/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-06 18:29:34
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2019-11-23 01:30:11
 * @Description: file content
 * 生成图片
 */
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import Canvastoimg from "wtc-canvastoimg";

const sharpness = 5;//清晰度
function getPoster(that) {
  return new Promise(function (resolve, reject) {
    /**
     * 1、获取海报图列表，随机抽取一张
     * 2、获取小程序码
     */

    let h5url = "";

    if (that.$pageType == that.$enumPageType.t3) {
      h5url = `https://${location.host}/h5/t3?id=${that.$route.query.id}&psn=${that.$route.query.psn}&refereeopenid=${that.$openid}&rscuid=${that.shareSpreadInfo.rscuid}`;
    } else if (that.$pageType == that.$enumPageType.t4) {
      h5url = `https://${location.host}/h5/t4?id=${that.$route.query.id}&psn=${that.$route.query.psn}&refereeopenid=${that.$openid}&rscuid=${that.shareSpreadInfo.rscuid}`;
    } else if (that.$pageType == that.$enumPageType.vcard) {
      h5url = `https://${location.host}/h5/vcard?refereeopenid=${that.$openid}&rscuid=${that.shareSpreadInfo.rscuid}`;
    }
    let companyid = '';
    if (that.hdkUserInfo && that.hdkUserInfo.User && that.hdkUserInfo.User.CompanyId) {
      companyid = that.hdkUserInfo.User.CompanyId;
    }
    Promise.all([
      comreq.openSmpicmaterials(that.cardInfo.AppGzh.Id, companyid),
      comreq.wxAcode(that, "pages/webview/common/common", {
        url: encodeURIComponent(h5url)
      })
    ]).then(function (res) {

      if (!(res[0] && res[0].List && res[0].Total > 0 && res[1])) {
        // util.messageBox("请稍后重试！")
        return;
      }

      let imgUrl = "";//最终生成的图片链接
      let bgImgUrl = res[0].List[util.randomNum(0, res[0].List.length - 1)].ImageUrl;//海报背景,随机从海报列表选一张
      let bgCover = "https://assets.rurushishi.com/yq-rs-make/utils/createimg/poster/bg-cover.png";//海报透明层
      let bottomVein = "https://assets.rurushishi.com/yq-rs-make/utils/createimg/poster/bottom-vein3.png";//底部纹理
      let xcxQrcode = res[1];
      let nwmFontSize = 14;//姓名，微信，手机 文字大小。
      let cvsImgData = [
        {
          type: "img",
          shape: "", //默认是矩形，  'arc代表画圆'
          zIndex: 1,
          x: 0,
          y: 0,
          width: 375 * sharpness,
          height: 523 * sharpness,
          content: bgImgUrl
        },
        {
          type: "img",
          zIndex: 1,
          x: 0,
          y: 523 * sharpness,
          width: 375 * sharpness,
          height: 144.5 * sharpness,
          content: bottomVein,
        },
        {
          type: "img",
          shape: "arc",
          zIndex: 2,
          x: 27 * sharpness,
          y: 485 * sharpness,
          width: 66 * sharpness,
          height: 66 * sharpness,
          content: that.cardInfo.Ui.HeadImg,
        },
        {
          type: "text",
          zIndex: 2,
          fontSize: `${nwmFontSize * sharpness}px 微软雅黑`,
          x: 32 * sharpness,
          y: 563 * sharpness,
          content: "姓名：",
          color: "#333333"
        },
        {
          type: "text",
          zIndex: 2,
          fontSize: `${nwmFontSize * sharpness}px 微软雅黑`,
          x: (32 + nwmFontSize * 3) * sharpness,
          y: 563 * sharpness,
          content: that.cardInfo.Ui.Name,
          color: "#333333"
        },
        {
          type: "text",
          zIndex: 2,
          fontSize: `${nwmFontSize * sharpness}px 微软雅黑`,
          x: 32 * sharpness,
          y: (563 + 30) * sharpness,
          content: "微信：",
          color: "#333333"
        },
        {
          type: "text",
          zIndex: 2,
          fontSize: `${nwmFontSize * sharpness}px 微软雅黑`,
          x: (32 + nwmFontSize * 3) * sharpness,
          y: (563 + 30) * sharpness,
          content: that.cardInfo.User.Wechat,
          color: "#333333"
        },
        {
          type: "text",
          zIndex: 2,
          fontSize: `${nwmFontSize * sharpness}px 微软雅黑`,
          x: 32 * sharpness,
          y: (563 + 30 * 2) * sharpness,
          content: "手机：",
          color: "#333333"
        },
        {
          type: "text",
          zIndex: 2,
          fontSize: `${nwmFontSize * sharpness}px 微软雅黑`,
          x: (32 + nwmFontSize * 3) * sharpness,
          y: (563 + 30 * 2) * sharpness,
          content: that.cardInfo.User.Phone,
          color: "#333333"
        },
        {
          type: "img",
          zIndex: 2,
          x: 265 * sharpness,
          y: 535 * sharpness,
          width: 90 * sharpness,
          height: 90 * sharpness,
          content: xcxQrcode,
        },
        // {
        //   type: "text",
        //   zIndex: 2,
        //   fontSize: `${9 * sharpness}px 微软雅黑`,
        //   x: (265 + 10) * sharpness,//小于12字体在chrome展示位12，这里要在手机上看
        //   y: (535 + 90 + 5) * sharpness,
        //   content: "扫一扫，了解更多",
        //   color: "#F87070"
        // }, {
        //   type: "text",
        //   zIndex: 2,
        //   fontSize: `${9 * sharpness}px 微软雅黑`,
        //   x: (265 + 5) * sharpness,//小于12字体在chrome展示位12，这里要在手机上看
        //   y: (535 + 90 + 5 + 18) * sharpness,
        //   content: "由很多客小程序生成",
        //   color: "#F87070"
        // },
        {
          type: "text",
          zIndex: 2,
          fontSize: `${12 * sharpness}px 微软雅黑`,
          x: (265 + 4 - 4) * sharpness,//小于12字体在chrome展示位12，这里要在手机上看
          y: (535 + 90 + 5) * sharpness,
          content: "扫一扫，了解更多",
          color: "#000000"
        }, {
          type: "text",
          zIndex: 2,
          fontSize: `${12 * sharpness}px 微软雅黑`,
          x: (265 - 6) * sharpness,//小于12字体在chrome展示位12，这里要在手机上看
          y: (535 + 90 + 5 + 18) * sharpness,
          content: "由很多客小程序生成",
          color: "#F87070"
        },
      ];
      if (that.$pageType == that.$enumPageType.t3 || that.$pageType == that.$enumPageType.t4) {
        // 添加透明层
        cvsImgData.push({
          type: "img",
          zIndex: 2,
          x: 0,
          y: 0,
          width: 375 * sharpness,
          height: 523 * sharpness,
          content: bgCover
        })
        // 标题，描述处理
        let tmpStrList = [];
        let tmpStrListIndex = 0;
        for (let index = 0; index < that.pageInfo.BrowserTabTitle.length; index++) {
          if (tmpStrListIndex == 0 || tmpStrListIndex >= (22 * tmpStrList.length)) {
            tmpStrList.push(that.pageInfo.BrowserTabTitle[index]);
          } else {
            tmpStrList[tmpStrList.length - 1] += that.pageInfo.BrowserTabTitle[index];
          }
          // 处理中英文占的长度
          tmpStrListIndex += util.getStrBlen(that.pageInfo.BrowserTabTitle[index]);
        }
        for (let index = 0; index < tmpStrList.length; index++) {
          let item = {
            type: "text",
            zIndex: 2,
            fontSize: `${30 * sharpness}px 微软雅黑`,
            x: 19 * sharpness,
            y: (19 + 38 * index) * sharpness,
            content: tmpStrList[index],
            color: "#ffffff"
          }
          cvsImgData.push(item);
        }
        if (that.pageInfo.WxShare && that.pageInfo.WxShare.Description) {
          let tmpStrList2 = [];
          let tmpStrList2Index = 0;
          for (let index = 0; index < that.pageInfo.WxShare.Description.length; index++) {
            if (tmpStrList2Index == 0 || tmpStrList2Index >= (40 * tmpStrList2.length)) {
              tmpStrList2.push(that.pageInfo.WxShare.Description[index]);
            } else {
              tmpStrList2[tmpStrList2.length - 1] += that.pageInfo.WxShare.Description[index];
            }
            // 处理中英文占的长度
            tmpStrList2Index += util.getStrBlen(that.pageInfo.WxShare.Description[index]);
          }
          for (let index = 0; index < tmpStrList2.length; index++) {
            let item = {
              type: "text",
              zIndex: 3,
              fontSize: `${17 * sharpness}px 微软雅黑`,
              x: 19 * sharpness,
              y: (19 + 10 + 38 * tmpStrList.length + 25 * index) * sharpness,//标题的y+margintop+标题的高度+描述的每次行高度
              content: tmpStrList2[index],
              color: "rgba(225,225,225,1)"
            }
            cvsImgData.push(item);
          }
        }
      } else if (that.$pageType == that.$enumPageType.vcard) {
        // 添加透明层
        cvsImgData.push({
          type: "img",
          zIndex: 2,
          x: 0,
          y: 0,
          width: 375 * sharpness,
          height: 523 * sharpness,
          content: bgCover
        })
        // 标题，描述处理
        let tmpStrList = [];
        let tmpStrListIndex = 0;
        let title = `我是${that.cardInfo.Ui.Name}`;
        if (that.cardInfo.Ui.Phone) {
          title += `，电话${that.cardInfo.Ui.Phone}`;
        }
        if (that.cardInfo.AppGzh.IndustryWords) {
          title += `，大家有${that.cardInfo.AppGzh.IndustryWords}需要，请随时联系我`
        }
        title += `，扫码跟我实时聊天`;

        let description = that.cardInfo.User.Intro;

        for (let index = 0; index < title.length; index++) {
          if (tmpStrListIndex == 0 || tmpStrListIndex >= (22 * tmpStrList.length)) {
            tmpStrList.push(title[index]);
          } else {
            tmpStrList[tmpStrList.length - 1] += title[index];
          }
          // 处理中英文占的长度
          tmpStrListIndex += util.getStrBlen(title[index]);
        }
        for (let index = 0; index < tmpStrList.length; index++) {
          let item = {
            type: "text",
            zIndex: 2,
            fontSize: `${30 * sharpness}px 微软雅黑`,
            x: 19 * sharpness,
            y: (19 + 38 * index) * sharpness,
            content: tmpStrList[index],
            color: "#ffffff"
          }
          cvsImgData.push(item);
        }
        if (description) {
          let tmpStrList2 = [];
          let tmpStrList2Index = 0;
          for (let index = 0; index < description.length; index++) {
            if (tmpStrList2Index == 0 || tmpStrList2Index % 40 == 0) {
              tmpStrList2.push(description[index]);
            } else {
              tmpStrList2[tmpStrList2.length - 1] += description[index];
            }
            // 处理中英文占的长度
            tmpStrList2Index += util.getStrBlen(description[index]);
          }
          for (let index = 0; index < tmpStrList2.length; index++) {
            let item = {
              type: "text",
              zIndex: 3,
              fontSize: `${17 * sharpness}px 微软雅黑`,
              x: 19 * sharpness,
              y: (19 + 10 + 38 * tmpStrList.length + 25 * index) * sharpness,//标题的y+margintop+标题的高度+描述的每次行高度
              content: tmpStrList2[index],
              color: "rgba(225,225,225,1)"
            }
            cvsImgData.push(item);
          }
        }
      }


      const cvsimg = new Canvastoimg({
        width: 375 * sharpness, //画布宽度
        height: 667 * sharpness, //画布高度
        color: "#ffffff", //画布背景色
        data: cvsImgData
      });
      cvsimg.down().then(canvas => {
        /* 获取到的是canvas对象 */
        imgUrl = canvas.toDataURL("image/jpg");
        resolve(imgUrl);
      });


    })



  })
}

export default {
  getPoster
}